export default __webpack_public_path__ + "15eb9c9311fb730216e09c68cf71d266.png";